import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { AdminHeader } from "./AdminLayout";
import { toast } from "sonner";
import { Star, Check, X } from "lucide-react";

export default function AdminReviews() {
  const [reviews, setReviews] = useState([]);
  const [filter, setFilter] = useState("pending");
  const load = () => api.get(`/admin/reviews${filter ? `?status=${filter}` : ""}`).then(r => setReviews(r.data));
  useEffect(() => { load(); }, [filter]);
  const moderate = async (r, status) => { await api.put(`/admin/reviews/${r.id}`, { status }); toast.success(status); load(); };
  return (
    <div>
      <AdminHeader title="Reviews" action={
        <div className="flex gap-2">{["pending", "approved", "rejected", ""].map((s) => (
          <button key={s} onClick={() => setFilter(s)} className={`text-xs px-3 py-1.5 border ${filter === s ? "bg-forest text-ivory" : "border-sage/40"}`}>{s || "All"}</button>
        ))}</div>} />
      <div className="space-y-3">
        {reviews.length === 0 && <p className="text-forest/50">No reviews.</p>}
        {reviews.map((r) => (
          <div key={r.id} className="bg-white border border-sage/30 rounded-sm p-4 flex justify-between gap-4">
            <div>
              <div className="flex items-center gap-2 mb-1"><div className="flex gap-0.5">{Array.from({ length: r.rating }).map((_, i) => <Star key={i} size={12} className="fill-forest text-forest" />)}</div><span className="text-xs text-forest/50">{r.name} · {r.product_slug} {r.verified && "· Verified"}</span></div>
              <div className="serif text-lg">{r.title}</div><p className="text-sm text-forest/65">{r.body}</p>
              <span className={`text-[10px] uppercase px-2 py-0.5 mt-1 inline-block ${r.status === "approved" ? "bg-moss/20 text-moss" : r.status === "rejected" ? "bg-brown/20 text-brown" : "bg-beige"}`}>{r.status}</span>
            </div>
            <div className="flex flex-col gap-2">
              <button onClick={() => moderate(r, "approved")} className="p-2 bg-moss/15 text-moss" data-testid={`approve-${r.id}`}><Check size={16} /></button>
              <button onClick={() => moderate(r, "rejected")} className="p-2 bg-brown/15 text-brown"><X size={16} /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
